import { dataroomUrl } from '@dataroom/url';
import drsUrl from '@drs/url';
import dataroomConfig from '@dataroom/config';
import config from '@allocate/config';
import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';
import evercallUrl from '@evercall/url';
import allocateUrl from '@allocate/config/allocateUrl';
import cfrUrl from '@/creditflowresearch/infrastructure/url';

import styles from './layout.module.scss';

export const ALLOCATE_LANDING_HEADER_MENU: Array<{ key: string, title: string, path: string }> = [];

export const ALLOCATE_LANDING_FOOTER_CONFIG = (
  {
    navigation: [
      {
        path: finsightWebUrl.getComplianceUrl(),
        title: 'Compliance',
        shouldOpenInNewTab: true,
      },
      {
        path: finsightWebUrl.getPrivacyPolicyUrl(),
        title: 'Privacy',
        shouldOpenInNewTab: true,
      },
      {
        path: finsightWebUrl.getSecurityPolicyUrl(),
        title: 'Security',
        shouldOpenInNewTab: true,
      },
      {
        path: finsightWebUrl.getTermsOfUseUrl(),
        title: 'Terms',
        shouldOpenInNewTab: true,
      },
    ],
    content: [
      {
        key: 'company',
        title: 'Company',
        columnClassName: styles.footerCol,
        collection: [
          {
            title: 'About',
            path: finsightWebUrl.getAboutUrl(),
            shouldOpenInNewTab: true,
          },
          {
            title: 'Careers',
            path: finsightWebUrl.getCareersUrl(),
            shouldOpenInNewTab: true,
          },
          {
            title: 'Contact',
            path: finsightWebUrl.getContactUsUrl(),
            shouldOpenInNewTab: true,
          },
          {
            title: 'Solutions',
            path: finsightWebUrl.getOurProductsUrl(),
            shouldOpenInNewTab: true,
          },
        ],
      },
      {
        key: 'products',
        title: 'Products',
        columnClassName: styles.footerCol,
        collection: [
          {
            title: 'Deal Roadshow',
            path: drsUrl.getUrl(),
            shouldOpenInNewTab: true,
          },
          {
            title: 'DealVDR',
            path: dataroomUrl(dataroomConfig.dealvdr.code)
              .getUrl(),
            shouldOpenInNewTab: true,
          },
          {
            title: 'Evercall',
            path: evercallUrl.getUrl(),
            shouldOpenInNewTab: true,
          },
          {
            title: 'CreditFlow',
            path: cfrUrl.getUrl(),
            shouldOpenInNewTab: true,
          },
          {
            title: 'VeriSend',
            path: dataroomUrl(dataroomConfig.verisend.code)
              .getUrl(),
            shouldOpenInNewTab: true,
          },
        ],
      },
      {
        key: 'resources',
        title: 'Resources',
        columnClassName: styles.footerCol,
        collection: [
          {
            title: 'Log In',
            path: allocateUrl.getLoginUrl(),
          },
          {
            title: 'Register',
            path: allocateUrl.getRegisterUrl(),
          },
        ],
      },
      {
        key: 'sales',
        title: 'Sales & Support',
        columnClassName: styles.footerCol,
        collection: [
          {
            title: 'Americas',
            phoneNumber: '+1 888 997 6610 ',
          },
          {
            title: 'APAC',
            phoneNumber: '+852 3018 1600',
          },
          {
            title: 'EMEA',
            phoneNumber: '+44 80 8178 7364',
          },
          {
            title: config.supportEmail,
            path: `mailto:${ config.supportEmail }`,
            linkClassName: styles.mailLink,
          },
        ],
      },
    ],
  }
);
